<template>
    <div
        class="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-ds-primary-100 px-2 py-[2px] text-content-md text-content-primary"
    >
        <span
            class="inline-block size-2 rounded-full"
            :class="`ds-tag-${variant}`"
        ></span>
        {{ text }}
    </div>
</template>

<script setup lang="ts">
export interface TagCoreProps {
    text: string;
    variant: 'success' | 'active' | 'error' | 'inactive' | 'warning';
}

defineProps<TagCoreProps>();
</script>

<style scoped lang="scss">
.ds-tag-active {
    @apply bg-ds-blue-400;
}

.ds-tag-inactive {
    @apply bg-ds-gray-300;
}

.ds-tag-success {
    @apply bg-ds-green-400;
}

.ds-tag-warning {
    @apply bg-ds-yellow-300;
}

.ds-tag-error {
    @apply bg-ds-red-400;
}
</style>
